import { PF } from '@app/components/RecordModal/data/constants';
import { padIdWithZeros } from '@app/components/RecordModal/utils';

import type { FC } from 'react';

interface RecordMenuLabelProps {
  recordId?: number;
}

export const RecordMenuLabel: FC<RecordMenuLabelProps> = ({
  recordId = null,
}) => (
  <div className={`${PF}__sidebar-record-label`}>
    <div
      className={`${PF}__sidebar-record-label-title`}
      data-testid="record-title"
    >
      Запись
    </div>
    {recordId !== null && (
      <div className={`${PF}__sidebar-record-label-id`}>
        #{padIdWithZeros(recordId)}
      </div>
    )}
  </div>
);
